import React from 'react';
import { Layout } from 'antd';
import SiteOutage from '../SiteOutage';
import WebsiteIndexEntryTabs from '../../deepAnalysis/websiteIndexEntry/WebsiteIndexEntryTabs';

export default function SiteOutagePage() {
    return (
        <Layout.Content className="general-layout-content">
            <WebsiteIndexEntryTabs>
                <SiteOutage />
            </WebsiteIndexEntryTabs>
        </Layout.Content>
    );
}
